import { Alert } from "@mui/material";
import Button from "components/common/Button";
import Column from "components/common/Column";
import Row from "components/common/Row";
import { Card } from "react-bootstrap";

const UserInformationCard = ({ cardHeaderText, name, email, role, status, change, buttonText = 'Change', showButton, infoText, cardColor }) => {
    return (
        <Card className={`${cardColor} p-5 rounded-0 h-100`}>
                <h2>{cardHeaderText}</h2>
            {
                name ? (
                    <Row className={"mb-3"}>
                        <Column col={6}>
                            <p className="mb-2 h5 text-primary">{name}</p>
                            <p className="mb-3 text-muted">{role}</p>
                        </Column>
                        <Column col={6}>
                            <div className="mb-2">
                                <strong className="d-inline-block me-2">Status: </strong>
                                <p className={`d-inline-block ${status === "Active" ? "text-success" : "text-danger"} mb-0`}>{status}</p>
                            </div>
                            <div className="text-muted small">{email}</div>
                        </Column>
                    </Row>
                ) : (
                    <Alert severity="info" sx={{ justifyContent: "left", fontSize: "12px"}} className={cardColor}>
                        {infoText}
                    </Alert>
                )
            }
            {
                showButton && (
                    <div className="bg-transparent border-0 text-left">
                        <Button onClick={change} className="btn btn-outline rounded-5 p-2">
                            {buttonText}
                        </Button>
                    </div>
                )
            }
        </Card>
    );
}

UserInformationCard.defaultProps = {
    cardHeaderText: "",
    name: "",
    email: "user@example.com",
    role: "User Role",
    status: "Active",
    change: () => { },
    showButton: true,
    buttonText: "Change",
    infoText: "Info Message",
    cardColor: "bg-green-light-5",
}

export default UserInformationCard;
